import type { CheckoutUrlRootBuilder } from './CheckoutUrlRootBuilder';

/** Cancel / back hooks (room to grow beyond a redirect). */
export class CancelHooks {
  constructor(private readonly root: CheckoutUrlRootBuilder) {}

  redirectTo(url: string): this {
    this.root.param('cancel_url', url);
    return this;
  }
}
